import { Log } from '@scayle/storefront-nuxt'
import type { LogEntry } from '@scayle/storefront-nuxt'

let _log: Log

export default (space?: any, sentry?: any) => {
  if (_log && !sentry) {
    return space ? _log.space(space) : _log
  }

  const handler = async (entry: LogEntry) => {
    const message = `[${entry.space}] ${entry.message}`

    if (entry.level === 'error') {
      sentry.withScope((scope: any) => {
        scope.setExtra('message', message)
        if (entry.data) {
          scope.setExtra('data', entry.data)
        }
        const error = (entry.data as any).error || message
        sentry.captureException(error)
      })
    }

    const logFn = console[entry.level] || console.log
    if (entry.data) {
      logFn(message, entry.data)
    } else {
      logFn(message)
    }
  }

  _log = new Log({
    space: import.meta.client ? 'client' : 'server',
    handler,
  })

  return space ? _log.space(space) : _log
}
